import { defineComponent as _defineComponent } from 'vue'
import i18n from '@/i18n';
import SIcon from '@/components/SIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NoDataAvailablePlaceholder',
  props: {
  text: { default: i18n.t('design.no_data_available') },
  disabled: { type: Boolean, default: false },
  secondaryText: { default: '' },
  icon: { default: 'icon-search' },
  learnMoreText: { default: i18n.t('common.words.learn_more') },
  learnMoreLink: { default: null },
  height: { default: '50vh' }
},
  setup(__props) {




return { __sfc: true,i18n, SIcon }
}

})